module.exports = __webpack_public_path__ + "img/content_1.0a7365f6.png";